import {Component, OnInit, ViewChild} from '@angular/core';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { StatusLeituraPipe } from '../../pipes/status-leitura.pipe';
import * as moment from 'moment';
import {EmpresaService} from '../../services/empresa/empresa.service';
import {SnotifyService} from 'ng-snotify';
import {ChartComponent} from '../../chart/generico/chart.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    @ViewChild('estatisticaGeralChart') estatisticaGeralChart: ChartComponent;

    @ViewChild('estatisticaMapasOperadorChart') estatisticaMapasOperadorChart: ChartComponent;

    public estatisticaGeral12Meses = null;

    public estatisticaOperadorChart = null;

    protected listaGrupos: any[] = [];

    protected gruposModel: any[];

    protected periodoModel: string = '7';

    protected chartsOperator = [];

    public dropdownSettingsGrupos = {
        singleSelection: false,
        idField: 'id',
        textField: 'descricao',
        itemsShowLimit: 2,
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        allowSearchFilter: true
    };

    constructor(
        private dashboardService: DashboardService,
        private empresaService: EmpresaService,
        private _notify: SnotifyService
    ) {}

    ngOnInit() {
        this._listar();
    }

    private _listar(): void {
        this._listarGrupos();
        this._estatisticaGeral();
        this._estatisticaOperadores();
        this.estatisticaOperadoresUpdateVsInsert();
    }

    private _listarGrupos(): void {
        this.empresaService.buscarEmpresasVinculadasGrupo().subscribe(({data}) => {
            const grupos = [];
            for (let i = 0; i < data.length; i++) {
                grupos.push({descricao: data[i].nome_grupo, id: data[i].id});
            }
            this.listaGrupos = grupos;
        });
    }

    private _estatisticaGeral(grupoEmpresa: Array<number> = []): void {
        const statusPipe = new StatusLeituraPipe();
        this.dashboardService.listar(grupoEmpresa).subscribe(
            ({data}) => {
                const labels = [];
                const datasets = [];
                Object.keys(statusPipe.getStatus()).forEach(status => {
                    let month = 12;
                    const _dataSet = {
                        label: statusPipe.getStatus()[status],
                        data: [],
                        fill: false,
                        borderColor: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
                        tension: 0.1
                    };
                    do {
                        const date = moment().subtract(month, 'month');
                        const dateSearch = date.format('YYYYM');
                        // tslint:disable-next-line:no-unused-expression
                        !labels.includes(date.format('MM/YYYY')) ? labels.push(date.format('MM/YYYY')) : null;
                        const result = data.month_year_status.filter((_data) => {
                            return _data.status == status && _data.month_year == dateSearch;
                        });
                        _dataSet.data.push(result.length === 0 ? 0 : result[0].qtd);
                        --month;
                    }while (month >= 0);
                    datasets.push(_dataSet);
                });
                this.estatisticaGeral12Meses = {
                    width: '1100px',
                    height: '600px',
                    labels: labels,
                    datasets: datasets
                };
                if (this.estatisticaGeralChart !== undefined) {
                    this.estatisticaGeralChart.update(this.estatisticaGeral12Meses);
                }
            },
            error => {
                console.error(error);
            }
        );
    }

    filterEstatisticaGeral(event = null): void {
        this.gruposModel = event == null ? this.gruposModel : event;
        if (this.gruposModel !== undefined) {
            const grupoEmpresa = this.gruposModel.map(item => {
                return typeof item == 'object' ? item.id : item;
            });
            this._estatisticaGeral(grupoEmpresa);
        }
    }

    private _estatisticaOperadores(periodo: string = '7'): void {
        this.dashboardService.listarMapasPorOperador(periodo).subscribe(
        (response) => {
            this.estatisticaOperadorChart = {
                width: '1100px',
                height: '600px',
                options: {
                    legend: {
                        display: false
                    }
                },
                labels: response.data.map((operador) => {
                    return operador.nome;
                }),
                datasets: [{
                    data: response.data.map(operador => {
                        return operador.qtd;
                    }),
                    backgroundColor: response.data.map((operador) => {
                        return operador.color != null ? operador.color : `#${Math.floor(Math.random() * 16777215).toString(16)}`;
                    }),
                    borderWidth: 1
                },
                ]
            };
            if (this.estatisticaMapasOperadorChart !== undefined) {
                console.log('resasda');
                this.estatisticaMapasOperadorChart.update(this.estatisticaOperadorChart);
            }
        }, error => {
            console.error(error);
        });
    }

    filterEstatisticaGeralOperadores(): void {
        this._estatisticaOperadores(this.periodoModel);
    }

    estatisticaOperadoresUpdateVsInsert(periodo: string = '7'): void {
        this.dashboardService.listarMapasPorOperadorUpdateVsInsert(periodo).subscribe(
            (response) => {
                const separetOperator = {};
                response.data.forEach((data) => {
                    if (separetOperator[data.id_operador] === undefined) {
                        separetOperator[data.id_operador] = {
                            nome: data.nome
                        };
                    }
                    separetOperator[data.id_operador][data.type] = data.qtd;
                });
                this.chartsOperator = Object.keys(separetOperator).map((key) => {
                    return {
                        nomeOperador: separetOperator[key].nome,
                        labels: ['Inseridos', 'Atualizados'],
                        datasets: [{
                            data: [separetOperator[key].INSERT !== undefined ? separetOperator[key].INSERT : 0, separetOperator[key].UPDATE !== undefined ? separetOperator[key].UPDATE : 0],
                            backgroundColor: ['green', 'blue']
                        }]
                    };
                });
                console.log(this.chartsOperator);
            }, error => {
               console.error(error);
            }
        );
    }
}
